import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { T } from '../styles/theme';

export default function AuthCallbackCollab() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser } = useAuth();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const token = searchParams.get('token');
    if (token) {
      localStorage.setItem('token', token);
      localStorage.setItem('impero_jwt_token', token); // sync bridge estensione
      // setUser minimale — PrivateRoute farà il check completo
      setUser({ ruolo: 'collaboratore' });
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
      <div style={{ width: 48, height: 48, borderRadius: '50%', border: `3px solid ${T.border}`, borderTopColor: T.violetDark, animation: 'spin 1s linear infinite' }} />
      <p style={{ fontFamily: T.fontBody, color: T.muted, fontSize: '0.9rem' }}>Accesso in corso...</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
